var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"title"},[_vm._v(" Studies ")]),_c('label',{staticClass:"label is-large",attrs:{"for":"studies-table"}},[_vm._v("Current Studies")]),_c('BaseTable',{attrs:{"id":"studies-table","tabledata":_vm.reducedData,"headings":_vm.headings,"linkto":"update_study"}}),_c('CreateStudy')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }